import http from '@/utils/request';

// 补款申请单-审核列表
export const getSupplementApplyBopList = (data = {}) => {
  return http.post({
    url: '/payment/supplement/applyBopList',
    data,
  });
};

// 补款申请-审核详情
export const getApplyDetail = (data = {}) => {
  return http.post({
    url: '/payment/supplement/applyDetail',
    data,
  });
};

// 补款申请-批量审核
export const setSupplementApproval = (data = {}) => {
  return http.post({
    url: '/payment/supplement/batchApproval',
    data,
  });
};

// 补款单-列表
export const getSupplementBopList = (data = {}) => {
  return http.post({
    url: '/finance-payment-server/payment/supplement/orderBopList',
    data,
  });
};

// 补款单-详情
export const getSupplementDetail = (data = {}) => {
  return http.post({
    url: '/payment/supplement/orderDetail',
    data,
  });
};

// 补款单-操作
export const setSupplementOperate = (data = {}) => {
  return http.post({
    url: '/payment/supplement/operate',
    data,
  });
};
